import { InlineText1, InlineText2 } from '@cian/ui-kit/typography/InlineText';

import { FC } from 'react';

import { IOperatorInfoProps } from './types';

import * as styles from './OperatorInfo.css';

export const OperatorInfo: FC<IOperatorInfoProps> = props => {
  const { name, type } = props;

  return (
    <div className={styles['container']}>
      <InlineText1 as="span" color="black_100" fontWeight="normal">
        {name}
      </InlineText1>
      <div className={styles['user-type-container']}>
        <InlineText2 as="span" color="gray60_100" fontWeight="normal">
          {type}
        </InlineText2>
      </div>
    </div>
  );
};

OperatorInfo.displayName = 'OperatorInfo';
